const profileBanner = {
  "profile.banner.edit-profile": "Editar perfil",
  "profile.banner.byb-iq": "BYB IQ",
  "profile.banner.global-rank": "Rango Global",
  "profile.banner.rating": "Calificación",
};

const profileLeague = {
  "profile.league.title": "Liga",
  "profile.league": "Liga {{ name }}",
  "profile.league.division": "División {{ name }}",
};

const profileChallenges = {
  "profile.challenges.title": "Desafíos",
  "profile.challenges.empty": "Aún no has completado ningún desafío.",
  "profile.challenges.see.all": "Ver todos",
};

const profileRewards = {
  "profile.rewards.title": "Recompensas",
  "profile.rewards.empty": "Todavía no has ganado ninguna recompensa.",
  "profile.rewards.load-error": "No se pudieron cargar las recompensas.",
  "profile.rewards.retry": "Reintentar",
  "profile.rewards.see.all": "Ver todas",
};

const profileDetails = {
  "profile.details.title": "Detalles",
  "profile.details.name": "Nombre",
  "profile.details.first-name": "Nombre",
  "profile.details.last-name": "Apellido",
  "profile.details.gender": "Género",
  "profile.details.email": "Correo electrónico",
  "profile.details.phone": "Teléfono",
  "profile.details.country": "País",
  "profile.details.city": "Ciudad",
  "profile.details.address": "Dirección",
  "profile.details.postal-code": "Código Postal",
  "profile.details.birthday": "Cumpleaños",
  "profile.details.years-old": " años",
  "profile.details.member-since": "Miembro desde",
};

const profileMenu = {
  "profile.menu.alt": "Perfil",
  "profile.menu.my-account": "Mi Cuenta",
  "profile.menu.switch-profile": "Cambiar Perfil",
  "profile.menu.switch-account": "Cambiar Cuenta",
  "profile.menu.sign-out": "Cerrar Sesión",
};

const profilePageMobile = {
  "profile.page.mobile.title": "Configuración de Perfil",
  "profile.page.mobile.save": "Guardar Cambios",
};

const profileImageUploader = {
  "profile.image-uploader.new-avatar": "Nuevo avatar",
  "profile.image-uploader.delete-avatar": "Eliminar avatar",
  "profile.image-uploader.upload.no-image": "Por favor, seleccione una imagen primero.",
  "profile.image-uploader.upload.error": "Algo salió mal. Por favor, inténtelo de nuevo.",
  "profile.image-uploader.upload.success": "Imagen cargada y procesada correctamente!",
  "profile.image-uploader.upload.failed": "Error al cargar y procesar la imagen. Por favor, asegúrese de que sea apropiada.",
};

const profileTrophyRoom = {
  "profile.trophy-room.title": "Trophy Room",
  "profile.trophy-room.subtitle": "Tus recompensas",
  "profile.trophy-room.empty": "Aún no has ganado ninguna recompensa.",
  "profile.trophy-room.see.all": "Ver todas",
  "profile.trophy-room.rewards.label": "Recompensas",
  "profile.trophy-room.rewards.count": "{{ count }} recompensas",
};

const profileSettings = {
  "profile.settings.first.name": "Nombre",
  "profile.settings.last.name": "Apellido",
  "profile.settings.email": "Correo electrónico",
  "profile.settings.dob": "Fecha de nacimiento",
  "profile.settings.gender": "Género",
  "profile.settings.gender.na": "N/A",
  "profile.settings.gender.male": "Masculino",
  "profile.settings.gender.female": "Femenino",
  "profile.settings.button.saving": "Guardando...",
  "profile.settings.button.save": "Guardar cambios",
  "profile.settings.validation.first.name": "Debes ingresar un nombre",
  "profile.settings.validation.last.name": "Debes ingresar un apellido",
  "profile.settings.validation.country.code": "El código del país debe tener 2 letras",
  "profile.settings.country-code.placeholder": "ej. PT",
  "profile.settings.country.none": "Ninguno",
  "profile.settings.completion": "{{percentage}}% de perfil completado",
};

export const profile = {
  ...profileBanner,
  ...profileLeague,
  ...profileChallenges,
  ...profileRewards,
  ...profileDetails,
  ...profileMenu,
  ...profilePageMobile,
  ...profileImageUploader,
  ...profileTrophyRoom,
  ...profileSettings,
};
